import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

export const listVehicleFieldsMaster = (request) => {  
    const ENDPOINT = URL_BASE_API+'super-admin/vehicle-field-master_v2/';
    return service.get(ENDPOINT);
}

export const addVehicleFieldaMaster = (request) => {  
    const ENDPOINT = URL_BASE_API+'super-admin/vehicle-field-master_v2/';
    return service.post(ENDPOINT,request.data); 
}

export const updateVehicleFieldaMaster = (request) => {  
    let id = request.data.id
    const ENDPOINT = URL_BASE_API+'super-admin/vehicle-field-master_v2/'+id;
    return service.put(ENDPOINT,request.data); 
}

export const deleteVehicleFieldsMaster = (request) => {  
    let id = request.data
    const ENDPOINT = URL_BASE_API+'super-admin/vehicle-field-master_v2/'+id; 
    return service.delete(ENDPOINT,request.data); 
}

// export const listVehicleMasterInfo = (request) => {  
//     let ENDPOINT = URL_BASE_API+'affiliate/vehicle/?page=0&column=affiliatevehicledetails_set__id';
//     if(request.data){
//         ENDPOINT = URL_BASE_API+'affiliate/vehicle/?page=0&column=affiliatevehicledetails_set__id&crew_id='+request.data;
//     }
//     return service.get(ENDPOINT); 
// }
// export const saveVehicleMasterInfo = (request) => {  
//     let crew_id = '';
//     let data = request.data.vehicle_details;
//     let is_approved = request.data.is_approved?request.data.is_approved:false;
//     let ENDPOINT = URL_BASE_API+'affiliate/vehicle/?is_approved='+is_approved;
    
//     if(request.data.crewId){
//         crew_id = request.data.crewId
//         ENDPOINT = URL_BASE_API+'affiliate/vehicle/?crew_id='+crew_id+"&is_approved="+is_approved;
//     }
//     return service.post(ENDPOINT,data); 
// }
// export const updateVehicleMasterInfo = (request) => {  
// 	let id = request.data.id
// 	let vehicle_details = request.data.vehicle_details
//     let is_approved = request.data.is_approved?request.data.is_approved:false;
//     const ENDPOINT = URL_BASE_API+'affiliate/vehicle/'+id+"?is_approved="+is_approved;
//     return service.put(ENDPOINT,vehicle_details); 
// }
// export const deleteVehicleMasterInfo = (request) => {  
// 	let id = request.data
//     const ENDPOINT = URL_BASE_API+'affiliate/vehicle/'+id;
//     return service.delete(ENDPOINT); 
// }
// export const getVehicleMasterInfo = (request) => {  
// 	let id = request.data
//     const ENDPOINT = URL_BASE_API+'affiliate/vehicle/'+id;
//     return service.get(ENDPOINT); 
// }